import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import type { OffrandeImperee } from "@/lib/programme-offrandes";

/** Page « Ma semaine » (proposition du 02/11/2026). */
export const PAGE_MA_SEMAINE = 93;

export interface Fonctionnalites {
  maSemaine: boolean;
}

/**
 * Écrans encore en essai, allumés par environnement par le serveur de
 * l'application (`/api/fonctionnalites`) : « Ma semaine » sur DEV et
 * STAGING, en PROD au signal du PO. Éteint tant que la réponse n'est pas là.
 */
export function useFonctionnalites(): Fonctionnalites & { pret: boolean } {
  const { data, isFetched } = useQuery<Fonctionnalites>({
    queryKey: ["fonctionnalites"],
    staleTime: 10 * 60 * 1000,
    queryFn: async () => {
      const res = await apiRequest("GET", "/api/fonctionnalites");
      return (await res.json()) as Fonctionnalites;
    },
  });
  return { maSemaine: data?.maSemaine === true, pret: isFetched };
}

/** Pages retirées de toute navigation tant que leur écran est éteint. */
export function usePagesMasquees(): ReadonlySet<number> {
  const { maSemaine } = useFonctionnalites();
  return maSemaine ? AUCUNE : MA_SEMAINE_SEULE;
}
const AUCUNE: ReadonlySet<number> = new Set();
const MA_SEMAINE_SEULE: ReadonlySet<number> = new Set([PAGE_MA_SEMAINE]);

/** Offrandes impérées du programme diocésain dont la période touche [du, au]. */
export function useProgrammeOffrandes(du: string, au: string, actif = true) {
  return useQuery<OffrandeImperee[]>({
    queryKey: ["programme-offrandes", du, au],
    enabled: actif && !!du && !!au,
    staleTime: 30 * 60 * 1000,
    queryFn: async () => {
      const params = new URLSearchParams({ du, au });
      const res = await apiRequest("GET", `/api/micro/programme-offrandes?${params}`);
      const data = await res.json();
      return (data?.items ?? []) as OffrandeImperee[];
    },
  });
}
